import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { alpha } from '@mui/material/styles';

const StatCard = ({ title, value, icon, color = '#1A73E8', trend, trendValue }) => {
  const trendIsUp = trend === 'up';
  const trendIsDown = trend === 'down';

  return (
    <Card
      sx={{
        height: '100%',
        border: '1px solid #DADCE0',
        borderRadius: 2,
        '&:hover': {
          boxShadow: '0 1px 2px 0 rgba(60,64,67,0.3), 0 2px 6px 2px rgba(60,64,67,0.15)',
        },
      }}
    >
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontSize: '0.75rem',
                fontWeight: 500,
                color: '#5F6368',
                mb: 1,
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: '1.5rem',
                fontWeight: 500,
                color: '#202124',
                lineHeight: 1.2,
              }}
            >
              {value}
            </Typography>
            {(trendIsUp || trendIsDown) && trendValue && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, gap: 0.5 }}>
                {trendIsUp ? (
                  <TrendingUpIcon sx={{ fontSize: 16, color: '#1E8E3E' }} />
                ) : (
                  <TrendingDownIcon sx={{ fontSize: 16, color: '#D93025' }} />
                )}
                <Typography sx={{ fontSize: '0.75rem', fontWeight: 500, color: trendIsUp ? '#1E8E3E' : '#D93025' }}>
                  {trendValue}
                </Typography>
              </Box>
            )}
          </Box>
          {icon && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: '50%',
                backgroundColor: alpha(color, 0.08),
                color: color,
                flexShrink: 0,
              }}
            >
              {icon}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;
